import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import {
  BylawsDraft,
  BylawsWizardService,
} from 'src/app/tools/bylaws/services/bylaws-wizard.service';
import { BylawsRenderService } from 'src/app/services/bylaws-render.service';
import { SafeHtmlPipe } from 'src/app/core/pipes/safe-html.pipe';

@Component({
  standalone: true,
  selector: 'app-bylaws-preview',
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './bylaws-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BylawsPreviewComponent implements OnInit, OnDestroy {
  html = '';
  schemaVersion = '';
  templateVersion = '';
  errors: string[] = [];
  loading = false;

  private draft: BylawsDraft | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly wizard: BylawsWizardService,
    private readonly renderer: BylawsRenderService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const draftSub = this.wizard.draft$.subscribe((draft) => {
      this.draft = draft;
      this.refreshPreview();
    });
    this.subscriptions.push(draftSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  async refreshPreview(): Promise<void> {
    if (!this.draft) {
      this.reset();
      return;
    }

    this.loading = true;
    this.cdr.markForCheck();

    try {
      const result = await this.renderer.render(
        this.draft as unknown as Record<string, unknown>,
      );
      this.html = result.html;
      this.schemaVersion = result.schemaVersion;
      this.templateVersion = result.templateVersion;
      this.errors = result.errors;
    } catch (err) {
      this.errors = [
        err instanceof Error ? err.message : 'Failed to render preview',
      ];
      this.html = '';
      this.schemaVersion = '';
      this.templateVersion = '';
    } finally {
      this.loading = false;
      this.cdr.markForCheck();
    }
  }

  private reset(): void {
    this.html = '';
    this.schemaVersion = '';
    this.templateVersion = '';
    this.errors = [];
    this.loading = false;
    this.cdr.markForCheck();
  }
}
